import { render, staticRenderFns } from "./TrainingsForm.vue?vue&type=template&id=5413756e&scoped=true&"
import script from "./TrainingsForm.vue?vue&type=script&lang=js&"
export * from "./TrainingsForm.vue?vue&type=script&lang=js&"
import style0 from "./TrainingsForm.vue?vue&type=style&index=0&id=5413756e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413756e",
  null
  
)

export default component.exports